import React from "react";
import { useGlobalContext } from "../../context";
import Loading from "../Loading";
import ExamForm from "./ExamForm";

const Exams = () => {
  const { apiClient } = useGlobalContext();
  const [loading, setLoading] = React.useState(false);
  const [exams, setExams] = React.useState([]);
  const [selectedExam, setSelectedExam] = React.useState(false);

  async function removeExams(id) {
    if (window.confirm("Do you really want to delete this exam?")) {
      try {
        setLoading(true);
        const res = await apiClient.delete(`/exams/${id}`);
        setExams(exams.filter((e) => e.id !== id));
      } catch (error) {
        alert(error);
      } finally {
        setLoading(false);
      }
    }
  }

  async function updateExams(newExam) {
    const i = exams.findIndex((e) => e.id === newExam.id);
    if (i === -1) {
      setExams([...exams, newExam]);
    } else {
      const items = [...exams];
      items[i] = newExam;
      setExams(items);
    }
  }

  async function getExams() {
    try {
      setLoading(true);
      const res = await apiClient.get("/exams");
      const data = res.data;
      if (!data || data.length < 1) {
        setExams([]);
      } else {
        setExams(data);
      }
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    getExams();
  }, []);

  return (
    <>
      <div className="d-flex flex-column">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h4 className="text-muted">Exams ({exams.length})</h4>
          <div
            className="btn btn-sm btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#examFormModal"
            onClick={() => setSelectedExam(false)}
          >
            Add New Exam
          </div>
        </div>
        {loading ? (
          <Loading />
        ) : (
          exams.map((e) => (
            <div
              className="d-flex align-items-center bg-light rounded p-2 my-1"
              key={e.id}
            >
              <h6 className="me-auto mb-0 ps-2">{e.name}</h6>
              <div
                className="btn btn-sm btn-warning"
                data-bs-toggle="modal"
                data-bs-target="#examFormModal"
                onClick={() => setSelectedExam(e.id)}
              >
                Edit
              </div>
              <button
                className="btn btn-sm btn-danger ms-2"
                onClick={() => removeExams(e.id)}
              >
                Remove
              </button>
            </div>
          ))
        )}
      </div>
      <ExamForm
        exam={selectedExam}
        setLoading={setLoading}
        updateExams={updateExams}
      />
    </>
  );
};

export default Exams;
